<template>
  <section class="merchant-dashboard template-message-settings">
    <div>
      <!--<InfoBox
        info-name="template_message_settings_info"
        type="success">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. A alias amet autem dignissimos doloremque error
        esse explicabo incidunt ipsa ipsum maiores minima nulla, officiis quos repellat tempore vel voluptas voluptate.
      </InfoBox>-->
      <button
        class="btn btn-add-item btn-blue btn-round mb-3"
        @click="showAddTemplateModal">
        Create New Template
      </button>
      <div class="settings-form">
        <template v-if="templateMessagesLoaded">
          <b-card
            v-if="$lodash.isEmpty(templateMessageList)"
            class="card-pending">
            <h2>No template messages found.</h2>
          </b-card>
          <b-card
            v-for="(messages, keyword) in templateMessageList"
            v-else
            :key="keyword"
            no-body
            class="mb-3">
            <b-card-header v-b-toggle="`collapse-${keyword}`">
              <h3>{{ keyword }}</h3>
              <span
                class="arrow">
                <icon name="chevron-up"/>
              </span>
            </b-card-header>
            <b-collapse :id="`collapse-${keyword}`">
              <b-card-body>
                <div
                  v-for="message in messages"
                  :key="message.id"
                  class="card-item">
                  <div class="clearfix">
                    <b-col
                      cols="11"
                      class="px-0 message-content">
                      <MessageContent
                        :content="message.text"
                        :pre-lined="true"/>
                    </b-col>
                    <b-col
                      cols="1"
                      class="px-0 message-actions">
                      <b-dropdown
                        variant="link"
                        right
                        no-caret
                        no-flip>
                        <template slot="button-content">
                          <icon name="ellipsis-h"/>
                        </template>
                        <b-dropdown-item
                          @click="showDeleteMessageModal(message)">
                          Delete
                        </b-dropdown-item>
                      </b-dropdown>
                    </b-col>
                  </div>
                  <div class="card-item-footer">
                    <span class="selected-lang">{{ getLanguageName(message.language) || 'unknown' }}</span>
                    <span
                      v-if="message.status === 'approved'"
                      class="notification-status approved float-right">
                      <icon
                        width="13"
                        height="13"
                        name="check-circle"/> <span>Approved</span>
                    </span>
                    <span
                      v-else-if="message.status === 'rejected'"
                      class="notification-status rejected float-right">
                      <icon
                        width="13"
                        height="13"
                        name="times-circle"/> <span>Rejected - {{message.rejected_reason}}</span>
                    </span>
                    <span
                      v-else
                      class="notification-status pending float-right">
                      <icon
                        width="13"
                        height="13"
                        name="regular/clock"/> <span>Pending Approval</span>
                    </span>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
            <!--<b-card-footer>
              <span
                class="add-button"
                @click="openTemplateMessageModal(keyword)">
                <icon
                  width="12"
                  height="12"
                  name="plus"/> Add New Language
              </span>
            </b-card-footer>-->
          </b-card>
        </template>
        <div
          v-else
          class="card-loading">
          <div
            class="loader loader-main">
            <div class="loading-circle"/>
          </div>
        </div>
      </div>
    </div>
    <TemplateMessageAddNewModal
      ref="templateMessageAddNewModal"/>
    <TemplateMessageModal
      v-if="hasManageTemplateMessagesPermission"
      ref="templateMessageModal"
      :keywordp="selectedKeyword"
      @saved="getTemplateMessageList"/>
    <TemplateMessageDeleteModal
      v-if="hasManageTemplateMessagesPermission"
      ref="templateMessageDeleteModal"
      :template-messagep="selectedMessage"
      @deleted="getTemplateMessageList"/>
    <InfoModal
      ref="infoModal"
      message="You don't have permission to do this action."/>
  </section>
</template>

<script>
import '@/assets/css/modules/_template-message-settings.scss';

import { mapGetters, mapActions } from 'vuex';
import getLanguageName from '@/helpers/getLanguageName';
import TemplateMessageModal from './modals/TemplateMessageModal';
import TemplateMessageDeleteModal from './modals/TemplateMessageDeleteModal';
import TemplateMessageAddNewModal from './modals/TemplateMessageAddNewModal';
import InfoModal from '../../common/modals/InfoModal';
import MessageContent from '../../common/MessageContent';

export default {
  name: 'TemplateMessages',
  components: {
    MessageContent,
    TemplateMessageModal,
    TemplateMessageDeleteModal,
    TemplateMessageAddNewModal,
    InfoModal,
  },
  data() {
    return {
      selectedKeyword: '',
      selectedMessage: {},
    };
  },
  computed: {
    ...mapGetters({
      templateMessageList: 'notification/templateMessageList',
      templateMessagesLoaded: 'notification/templateMessagesLoaded',
      apiError: 'notification/apiError',
    }),
    hasManageTemplateMessagesPermission() {
      return this.$hasPermissionInOrganisation('manage_template_messages');
    },
  },
  watch: {
    templateMessagesLoaded(loaded) {
      if (loaded && this.selectedKeyword) {
        this.$nextTick(() => {
          this.$root.$emit('bv::toggle::collapse', `collapse-${this.selectedKeyword}`);
        });
      }
    },
  },
  mounted() {
    this.getTemplateMessageList();
  },
  methods: {
    ...mapActions({
      fetchTemplateMessages: 'notification/fetchTemplateMessages',
    }),
    getLanguageName,
    getTemplateMessageList(keyword) {
      this.selectedKeyword = keyword;
      this.fetchTemplateMessages(this.$route.params.merchant_id);
    },
    openTemplateMessageModal(keyword = null) {
      if (this.hasManageTemplateMessagesPermission) {
        this.selectedKeyword = keyword || '';
        this.$nextTick(() => {
          this.$refs.templateMessageModal.show();
        });
      } else {
        this.$refs.infoModal.show();
      }
    },
    showDeleteMessageModal(message) {
      if (this.hasManageTemplateMessagesPermission) {
        this.selectedMessage = message;
        this.$nextTick(() => {
          this.$refs.templateMessageDeleteModal.show();
        });
      } else {
        this.$refs.infoModal.show();
      }
    },
    showAddTemplateModal() {
      this.$refs.templateMessageAddNewModal.show();
    },
  },
};
</script>
